export default "__VITE_PUBLIC_ASSET__42a37897__"